import React, { memo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import Button from 'components/App/Button';
import Loading from 'components/App/Loading';

import {
  LOGIN_TYPE,
  LOCATIONS,
  LANDMARK_LIST,
  PLACE_TYPE,
  STATUS_LIST,
  storageKey,
} from 'constants/index';
import { actionLogout } from 'store/auth/profile/actions';
import axiosClient from 'utils/axios';
// import INITIAL_VALUE from 'constants/initialValue';
import { ReactComponent as SortIconSvg } from 'assets/images/location/sort-icon-svg.svg';
import NextArrowIcon from 'assets/images/next-arrow.svg';
import AppBadge from '../AppBadge';

import styles from './DataTableLocations.module.scss';

const getLocationStatusBadgeColor = (status) => {
  switch (status) {
    case 'READY':
      return 'success';
    case 'CONTACTING':
      return 'caution';
    case 'ASSIGNED':
      return 'info';
    case 'CHANGED_OWNER':
      return 'neutral';
    default:
      return 'info';
  }
};

function SortableHeader({ children, columnSortBy, onSort, style }) {
  return (
    <th className="Table__Header__Row__Content" style={style}>
      <button
        type="button"
        className="SortHeader"
        onClick={() => onSort(columnSortBy)}
      >
        <span>{children}</span>
        <SortIconSvg className="SortHeader__Icon" />
      </button>
    </th>
  );
}

SortableHeader.propTypes = {
  children: PropTypes.node.isRequired,
  columnSortBy: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  style: PropTypes.shape({}),
};

SortableHeader.defaultProps = {
  style: {},
};

function DataTableLocations(props) {
  const { isLoadingLocationList, locations, onSort } = props;

  const history = useHistory();
  const dispatch = useDispatch();

  const onOpenExtranet = (event, placeId) => {
    event.preventDefault();

    localStorage.setItem(storageKey.LOGIN_TYPE, LOGIN_TYPE.EXTRANET);
    delete axiosClient.defaults.headers.Authorization;

    dispatch(actionLogout({ history }));
    localStorage.setItem('place', placeId);
  };

  // const ButtonType = useCallback((progress, locationId) => {
  //   if (progress) {
  //     return (
  //       <div className="d-flex">
  //         <Button
  //           outline
  //           classes="Action__Button Action__Button__Danger"
  //           onClick={onDeleteLocation}
  //           value={locationId}
  //         >
  //           Xóa
  //         </Button>

  //         <Button outline classes="Action__Button Action__Button__Link">
  //           Duyệt
  //         </Button>

  //         <Link to={`${LOCATIONS.LOCATION_DETAIL.DEFAULT}?place=${locationId}`}>
  //           <Button outline classes="Action__Button Action__Button__Link">
  //             Xem chi tiết
  //           </Button>
  //         </Link>
  //       </div>
  //     );
  //   }

  //   return (
  //     <div className="d-flex gap-3 mt-3">
  //       <Button
  //         outline
  //         classes="Action__Button Action__Button__Danger"
  //         onClick={onDeleteLocation}
  //         value={locationId}
  //       >
  //         Xóa
  //       </Button>

  //       <Link to={`${LOCATIONS.LOCATION_DETAIL.DEFAULT}?place=${locationId}`}>
  //         <Button outline classes="Action__Button Action__Button__Link">
  //           Xem chi tiết
  //         </Button>
  //       </Link>
  //     </div>
  //   );
  // }, []);

  return (
    <div className={styles.Component}>
      <Loading loading={isLoadingLocationList} loaderOnPage />
      <Table responsive className="Table">
        <thead className="Table__Header">
          <tr className="Table__Header__Row">
            <SortableHeader
              columnSortBy="placeId"
              onSort={onSort}
              style={{ minWidth: '321px' }}
            >
              Mã chỗ nghỉ | Chỗ nghỉ
            </SortableHeader>

            <SortableHeader
              columnSortBy="market"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Thị trường
            </SortableHeader>

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: '160px' }}
            >
              Khu vực
            </th>

            <SortableHeader
              columnSortBy="placeType"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Loại hình
            </SortableHeader>

            <SortableHeader
              columnSortBy="starRating"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Hạng sao
            </SortableHeader>

            <SortableHeader
              columnSortBy="status"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Trạng thái
            </SortableHeader>

            <SortableHeader
              columnSortBy="isPublished"
              onSort={onSort}
              style={{ minWidth: '200px' }}
            >
              Trạng thái đóng mở
            </SortableHeader>

            <SortableHeader
              columnSortBy="owner"
              onSort={onSort}
              style={{ minWidth: '180px' }}
            >
              Người phụ trách
            </SortableHeader>

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: '160px' }}
            >
              Email
            </th>

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: '160px' }}
            >
              Số điện thoại
            </th>

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: '160px' }}
            >
              Link Extranet
            </th>
          </tr>
        </thead>

        <tbody className="Table__Body">
          {locations.map((location) => (
            <tr className="Table__Body__Row" key={location._id}>
              <td className="Table__Body__Row__Content">
                <div className="d-flex flex-column">
                  <span className="Content__Id">{location.placeId || location._id}</span>
                  <span className="Content__Name">{location.name}</span>

                  <div className="Action">
                    <Link
                      to={`${LOCATIONS.LOCATION_DETAIL.DEFAULT}?place=${location._id}&edit=true`}
                    >
                      <Button
                        outline
                        classes="Action__Button Action__Button__Link"
                      >
                        Sửa
                      </Button>
                    </Link>

                    <Link
                      to={`${LOCATIONS.LOCATION_DETAIL.DEFAULT}?place=${location._id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button
                        outline
                        classes="Action__Button Action__Button__Link"
                      >
                        Xem chi tiết
                      </Button>
                    </Link>
                  </div>
                </div>
              </td>

              <td className="Table__Body__Row__Content">
                {location.market?.name}
              </td>

              <td className="Table__Body__Row__Content">
                {LANDMARK_LIST.find(
                  (item) => item.value === location.landmarks?.[0],
                )?.label || ''}
              </td>

              <td className="Table__Body__Row__Content">
                {PLACE_TYPE[location.placeType]?.label}
              </td>

              <td className="Table__Body__Row__Content">
                {`${location.starRating} sao`}
              </td>

              <td className="Table__Body__Row__Content">
                <AppBadge
                  color={getLocationStatusBadgeColor(location.status)}
                  className="Badge"
                >
                  {
                    STATUS_LIST.find((item) => item.value === location.status)
                      ?.label
                  }
                </AppBadge>
              </td>

              <td className="Table__Body__Row__Content">
                <AppBadge
                  className="Badge"
                  color={location.isPublished === true ? 'success' : 'error'}
                >
                  {location.isPublished === true ? 'Mở' : 'Đóng'}
                </AppBadge>
              </td>

              <td className="Table__Body__Row__Content">
                {location.market?.partnerServiceManager?.fullName}
              </td>

              <td className="Table__Body__Row__Content">
                {
                  location.placeContacts?.find((item) => item.group === 'MAIN')
                    ?.children?.[0]?.email
                }
              </td>

              <td className="Table__Body__Row__Content">
                {' '}
                {
                  location.placeContacts?.find((item) => item.group === 'MAIN')
                    ?.children?.[0]?.phoneNumbers?.[0]
                }
              </td>

              <td className="Table__Body__Row__Content">
                <div>
                  <Link
                    to={LOCATIONS.LOGIN}
                    className="Link__Extranet"
                    onClick={(event) => onOpenExtranet(event, location._id)}
                  >
                    <span>Link Extranet</span>
                    <img src={NextArrowIcon} alt="" className="Link__Extranet__Icon" />
                  </Link>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

DataTableLocations.propTypes = {
  isLoadingLocationList: PropTypes.bool.isRequired,
  locations: PropTypes.instanceOf(Array),
  onSort: PropTypes.func,
  // onDeleteLocation: PropTypes.func,
};

DataTableLocations.defaultProps = {
  locations: [],
  onSort: () => {},
  // onDeleteLocation: INITIAL_VALUE.FUNCTION,
};

export default memo(DataTableLocations);
